import styled from 'styled-components';

export const PageButton = styled.button<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.RG08};
  width: 32px;
  padding: 8px;
  aspect-ratio: 1 / 1;
  border-radius: 6px;
  cursor: pointer;
  svg > path {
    fill: ${({ theme }) => theme.colors.RG04};
  }

  ${({ disabled, theme }) =>
    disabled
      ? {
          cursor: 'not-allowed',
          'svg > path': {
            fill: theme.colors.RG06,
          },
        }
      : {
          ':hover': {
            'svg > path': {
              fill: theme.colors.RC03,
            },
            background: theme.colors.RC03_1,
          },
        }}

  transition: background 0.3s ease;
`;

export const PageListBox = styled.div<{ active: boolean }>`
  ${({ theme }) => theme.fontStyle.caption1}

  display: flex;
  align-items: center;
  justify-content: center;

  width: 24px;
  border-radius: 12px;
  aspect-ratio: 1 / 1;

  cursor: pointer;

  ${({ theme, active }) =>
    active
      ? {
          color: theme.colors.RG00,
          background: theme.colors.RC03,
        }
      : {
          color: theme.colors.RG02,
          background: theme.colors.RG00,

          ':hover': {
            background: theme.colors.RC03_3,
          },
        }}

  transition: background .3s ease;
`;
